export const WORKAREA_SET = "WORKAREA_SET";
export const SIGN_OUT_COMPLETE = "SIGN_OUT_COMPLETE";
